// extracted by mini-css-extract-plugin
export default {"settingsSection":"style--settingsSection--830c00","header":"style--header--d31fe6","description":"style--description--318456"};